import React from 'react';
import Grid from '@material-ui/core/Grid';
import AuthorCard from './AuthorCard';

export default class AuthorCards extends React.Component{
    render(){
        const { items } = this.props;
        return(
            items.length > 0 ? items.map((item, index) => {
                return(
                    <React.Fragment key={index}>
                        <AuthorCard item={item} />
                    </React.Fragment>
                )
            }) 
            : null
        )
    }
}
